export default __webpack_public_path__ + "static/top_point_img_002-76e58a97bd37c9701b607f0053e0c9f5.jpg";